import Loader from "react-loader-spinner";
import { faAngry, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { addEditComplaint, getComplaintBaseInfoes, getComplaintsSubGroup } from "../store/api/ComplaintsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { attachFile, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { getServiceSummaryList } from "../store/api/ServiceAPI";
import { useForm } from "react-hook-form";
import { CheckLg, List, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalProducts from "../../Components/Modals/ModalProducts";

const ModalAddNewComplaint = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { show, CustomerID } = popData;
    const complaintAttachment = useRef();
    const { errors, handleSubmit, register } = useForm();
    const settingNames = ["ProductGrouppingType"];
    const [isPending, setPending] = useState(false);
    const [baseInfoes, setBaseInfoes] = useState(null);
    const [subGroups, setSubGroups] = useState(null);
    const [customerServices, setCustomerServices] = useState(null);
    const [modalProducts, setModalProducts] = useState({ show: false });
    const { systemSettings } = useSelector(state => { return { systemSettings: state.SystemSettingsReducer.systemSettings } });
    const pgType = Array.isArray(systemSettings ?? "") ? Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    const history = useHistory();
    const [complaintData, setComplaintData] = useState({
        Priority: 3,
        DeadlineInDays: 5,
    });
    function close() {
        setPopData({
            show: false
        })
    }
    function showModalProducts(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectProduct = (p) => {
            if (p) {
                setComplaintData({ ...complaintData, ProductName: p.ProductName, ProductModel: p.ProductModel, ProductID: p.ProductID });
            }
        }

        setModalProducts({
            show: true,
            value: e?.key,
            setProductData: onSelectProduct
        })
    }
    function getServiceList(serial) {
        const onGet = (res) => {
            if (res.Data) {
                setCustomerServices(res.Data)
            }
            else if (res === "PENDING") {
                setCustomerServices("PENDING");
            }
        }
        getServiceSummaryList(CustomerID, serial ?? "", onGet);
    }
    function onSelectServiceTypeAndID(e) {
        const si = e.target.value;
        if (si === "") {
            setComplaintData({ ...complaintData, ProductName: null, ProductModel: null, ProductID: null, ProductSerial: null, FromService: false });
            return;
        }
        const serviceType = si.split("/")[0];
        const serviceID = Number(si.split("/")[1]);
        const cs = customerServices.find(s => s.ServiceType === serviceType && Number(s.ServiceID) === serviceID);
        setComplaintData({ ...complaintData, ProductID: cs.ProductID, ProductName: cs.ProductName, ProductModel: cs.ProductModel, ProductSerial: cs.ProductSerial, FromService: true });
    }
    function onSerialChanged(e) {
        setComplaintData({ ...complaintData, ProductSerial: e.target.value });
    }
    function loadSubGroups(mainGroupID) {
        getComplaintsSubGroup(mainGroupID, setSubGroups);
    }
    function attachNewFile(id) {
        let f = complaintAttachment.current.files;
        const onSuccess = () => {
            if (Number(id) > 0)
                history.push(`/CRM/Complaint/${id}`);
            setPending(false);
        }
        if (f.length > 0) {
            attachFile(complaintAttachment.current, id, "ComplaintsAttachment", onSuccess);
        }
        else {
            onSuccess();
        }
    }
    function onSubmit(data) {
        if ((data.RelatedServiceTypeAndID ?? "").length > 0)
            data.RelatedServiceID = data.RelatedServiceTypeAndID.split('/')[1];
        data.RelatedServiceType = data.RelatedServiceTypeAndID.split('/')[0];
        data.RelatedCustomerID = CustomerID;
        data.CustomerName = popData.CustomerName;
        data.CustomerMobile = popData.CustomerMobile;
        data.CustomerTel = popData.CustomerPhone;
        data.Priority = 2;
        data.DeadlineInDays = 5;
        setPending(true);
        dispatch(addEditComplaint(data, attachNewFile));
    };
    useEffect(() => {
        if (show) {
            getSystemSettings(settingNames);
            getServiceList();
            getComplaintBaseInfoes(setBaseInfoes);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <ModalProducts popData={modalProducts} setProductPopup={setModalProducts} productGrouppingType={pgType} />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faAngry} size="lg" />&nbsp;
                    ثبت شکایت مشتری
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <FormGroup className="col-md-3">
                            <label>گروه اصلی شکایت </label>
                            {!Array.isArray(baseInfoes?.MainGroupList ?? "") &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری اطلاعات
                                </div>
                            }
                            {Array.isArray(baseInfoes?.MainGroupList ?? "") &&
                                <select className="form-control" onChange={e => loadSubGroups(e.target.value)}>
                                    <option>انتخاب کنید</option>
                                    {baseInfoes.MainGroupList.map((item, i) =>
                                        <option key={i} value={item.MainGroupID}> {item.MainGroupName}</option>
                                    )}
                                </select>
                            }
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>گروه فرعی شکایت </label>
                            {subGroups === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری اطلاعات
                                </div>
                            }
                            {subGroups !== "PENDING" &&
                                <select className="form-control" name="GroupID" ref={register({})}>
                                    <option>انتخاب کنید</option>
                                    {Array.isArray(subGroups?.Data ?? "") && subGroups.Data.map((item, i) => {
                                        return (
                                            <option key={i} value={item.GroupID}> {item.GroupName}</option>
                                        )
                                    })}
                                </select>
                            }
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>بخش مورد شکایت</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری اطلاعات
                                </div>
                            }
                            {baseInfoes !== "PENDING" &&
                                <select className="form-control" name="TargetID" ref={register({})}>
                                    <option>انتخاب کنید</option>
                                    {Array.isArray(baseInfoes?.TargetList ?? "") && baseInfoes.TargetList.map((item, i) => {
                                        return (
                                            <option key={i} value={item.ID}> {item.Target}</option>
                                        )
                                    })}
                                </select>
                            }
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>نوع و شماره سرویس</label>
                            {customerServices === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری اطلاعات
                                </div>
                            }
                            {customerServices !== "PENDING" &&
                                <Form.Control as="select" name="RelatedServiceTypeAndID" ref={register({})} onChange={onSelectServiceTypeAndID} defaultValue={complaintData?.RelatedServiceTypeAndID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(customerServices ?? "") && customerServices.map((cs, i) => <option key={i} value={cs.ServiceTypeAndID}>{cs.PServiceType + " شماره " + cs.ServiceNumber}</option>)}
                                </Form.Control>
                            }
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <label>مشخصات محصول</label>
                            <input type="hidden" name="ProductID" ref={register({})} readOnly value={complaintData?.ProductID ?? ""} />
                            <Form.Control onKeyDown={showModalProducts} readOnly value={(complaintData?.HolderName ? complaintData.HolderName + "-" : "") + (complaintData?.ProductName ? complaintData.ProductName + '-' : "") + (complaintData?.ProductModel ?? "")} />
                            <Button className="btn-input-tiny" style={{ top: 26 }} onClick={showModalProducts} disabled={complaintData?.FromService ?? false}><List size={21} /></Button>
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>سریال محصول</label><span style={{ color: "red" }}>*</span>
                            <input type='text' className="form-control" name="ProductSerial" ref={register({ required: true })} value={complaintData?.ProductSerial ?? ""} onChange={onSerialChanged} readOnly={complaintData?.FromService ?? false} style={{fontFamily:"Dark-Sans", fontSize:"11.5px"}}/>
                            <Button className="btn-input-tiny" onClick={() => getServiceList(complaintData?.ProductSerial)} style={{ top: 26 }} disabled={complaintData?.FromService ?? false}><Search size={21} /></Button>
                            {errors.ProductSerial && <small className="errors"> شماره سریال را وارد کنید </small>}
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>وضعیت شکایت</label>
                            {!Array.isArray(baseInfoes?.StatusList ?? "") &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری اطلاعات
                                </div>
                            }
                            {Array.isArray(baseInfoes?.StatusList ?? "") &&
                                <select className="form-control" name="StatusID" ref={register({})} >
                                    <option value="">انتخاب کنید</option>
                                    {
                                        baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)
                                    }
                                </select>
                            }
                        </FormGroup>
                        <FormGroup className="col-md-3">
                            <label>پیوست</label>
                            <input className="form-control" style={{ fontSize: "13px" }} type="file" ref={complaintAttachment} />
                        </FormGroup>

                    </Row>
                    <Row className="rowBorder mt-2">
                        <FormGroup className="col-md-3">
                            <label>عنوان شکایت</label><span style={{ color: "red" }}>*</span>
                            <input type="text" className="form-control" name="Title" ref={register({ required: true })} />
                            {errors.Title && <small className="errors"> عنوان شکایت را وارد کنید </small>}
                        </FormGroup>
                        <FormGroup>
                            <label>متن شکایت</label><span style={{ color: "red" }}>*</span>
                            <Form.Control as="textarea" name="Body" ref={register({ required: true })} />
                            {errors.Body && <small className="errors"> متن شکایت را وارد کنید </small>}
                        </FormGroup>
                    </Row>

                    <Button variant="success" className="group-Btn-large mt-2" type="submit" disabled={isPending}>
                        {isPending && <Loader type="Watch" color="white" height={17} width={17} style={{ display: "inline-block" }} />}
                        {!isPending && <Fragment><CheckLg size={17} />&nbsp;ثبت شکایت</Fragment>}
                    </Button>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddNewComplaint;